/** QR code as inline SVG (qrcode-generator: zero dependencies, no network). */
import qrcode from "qrcode-generator";
import { useMemo } from "react";

export function Qr({ text, size = 200, label }: { text: string; size?: number; label: string }) {
  const svg = useMemo(() => {
    const qr = qrcode(0, "M");
    qr.addData(text);
    qr.make();
    const cells = qr.getModuleCount() + 4;
    return qr.createSvgTag({ cellSize: Math.max(2, Math.floor(size / cells)), margin: 2, scalable: true });
  }, [text, size]);
  return (
    <div
      role="img"
      aria-label={label}
      style={{ width: "100%", maxWidth: size, aspectRatio: "1 / 1" }}
      className="[&>svg]:h-full [&>svg]:w-full rounded-[var(--radius-card)] bg-white p-2"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
